import { CSSProperties, ReactNode } from 'react';

export type horizontalAlignType = 'left' | 'center' | 'right';
export type statusType = 'wait' | 'process' | 'finish' | 'error';

export interface StepsProps {
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 水平对齐方式 */
  horizontalAlign?: horizontalAlignType;
  /** 指定当前步骤，从 0 开始记数 */
  current?: number;
  /** 数据化配置选项内容 */
  options?: StepProps[];
  /** 指定当前步骤的状态 */
  status?: statusType;
  children?: ReactNode;
}

export interface StepProps {
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 指定状态 */
  status?: statusType;
  /** 描述信息 */
  description?: ReactNode;
  /** 操作用户 */
  operationUserName?: ReactNode;
  /** 操作时间 */
  operationTime?: ReactNode;
  /** 显示文字 */
  text?: ReactNode;
  /** 审批意见 */
  examineInfo?: ReactNode;
  children?: ReactNode;
}

export enum StepsEnum {
  Step = 'Step',
}
